/* React base class */
import { Component } from "react"

/* Portal renderer */
import { createPortal } from "react-dom"

/* Redux store connection */
import { connect } from "react-redux"

/* Icon component */
import Icon from "./Icon"

/* Translation */
import { translate } from "../translates"

/* Component CityModal */
class CityModal extends Component {

    componentDidMount = () => {

        /* Lock background scroll and close on Escape */
        document.addEventListener("keydown", this._onKey)
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {

        /* Restore scroll and remove the listener */
        document.removeEventListener("keydown", this._onKey)
        document.body.style.overflow = ""
    }

    /* Close on Escape */
    _onKey = (event) => {
        if (event.key === "Escape") {
            this.props.onClose()
        }
    }

    render = () => {

        /* Fields */
        const { onClose, city, cities, setCity } = this.props

        /* Portal to body — escapes the header's backdrop-filter containing block */
        return createPortal(
            <div className="modal-backdrop" onClick={onClose}>
                <div className="modal modal--sm" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">{translate("Выберите город")}</h3>
                        <button className="modal__close" onClick={onClose} aria-label={translate("Закрыть")}>
                            <Icon name="close" size={20} />
                        </button>
                    </div>
                    <div className="modal__body city-modal__body">
                        {Array.isArray(cities) && cities.map((item) => (
                            <button
                                key={`${item.id}`}
                                className={city && city.id === item.id ? "city-modal__item is-active" : "city-modal__item"}
                                onClick={() => { setCity(item); onClose() }}
                            >
                                <Icon name="pin" size={20} />
                                <div className="city-modal__name">{item.name}</div>
                            </button>
                        ))}
                    </div>
                </div>
            </div>,
            document.body
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        city: state.city,
        cities: state.data && state.data.cities ? state.data.cities : [],
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        setCity: cityData => dispatch({ type: "SET_CITY", payload: cityData })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(CityModal)
